import Modal from 'components/partials/modal/modal';

import { useCurrentUser } from 'state/current-user/current-user.thunk';
import { useDeleteFavoriteReport } from 'hooks/api/use-favorite-reports';

import type { FavoriteReportData } from '../farovite-report-tile/farovite-report-tile';

interface FavoriteModalRemoveProps {
  favoriteReport: FavoriteReportData;
  onClose: () => void;
  onSuccess?: () => void;
}

const FavoriteModalRemove = ({
  favoriteReport,
  onClose,
  onSuccess,
}: FavoriteModalRemoveProps): React.JSX.Element => {
  const currentUser = useCurrentUser();
  const deleteMutation = useDeleteFavoriteReport();

  const handleRemoveFromFavorites = async (): Promise<void> => {
    await deleteMutation.mutateAsync({
      oktaUserId: currentUser.data!.oktaUserId,
      userId: Number(currentUser.data!.id),
      bookmarkId: Number(favoriteReport.id),
    });

    onSuccess?.();
  };

  return (
    <Modal
      headerText={`Are you sure you want to remove ${favoriteReport.name} from favorites?`}
      headerSubtext="It wouldn't affect the report itself"
      onConfirmButtonLabel="Remove"
      onConfirmCallback={handleRemoveFromFavorites}
      onCloseCallback={onClose}
      loading={deleteMutation.isPending}
    />
  );
};

export default FavoriteModalRemove;
